export class ConfigModel<T> {
	_id: string;
	Name: string;
	Config: T;
}